import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { authApi } from 'modules/Auth/services/authApi'

import { AuthSliceState } from './type'

const initialState: AuthSliceState = {
  user: null,
  currentVersion: null,
}

export const AuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserData: (state, actions) => {
      state.user = actions.payload
    },
    destroyAuth: (state) => {
      state.user = null
    },
    setCurrentVersion: (state, { payload }: PayloadAction<string>) => {
      state.currentVersion = payload
    },
  },
  extraReducers: (build) => {
    build.addMatcher(
      authApi.endpoints.getMe.matchFulfilled,
      (state, { payload }) => {
        state.user = payload.result
      },
    )
  },
})

export const { setUserData, destroyAuth, setCurrentVersion } = AuthSlice.actions

export const authSlice = AuthSlice.reducer
